var _g, _g2, _path, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 15869",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4542_72083",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 19,
    height: 26
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b752ec9409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 2H21.6967V27.8102H3V2Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4542_72083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.6743 13.9254V2.95394C21.6743 2.43042 21.253 2 20.7406 2H8.24654C7.87839 2 7.51895 2.15299 7.25841 2.41919L3.41027 6.35098C3.14973 6.61719 3 6.98445 3 7.3606V26.8043C3 27.3302 3.41943 27.7587 3.93364 27.7587H17.4726L21.6743 13.9254Z",
    fill: "#6E52F9"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.66886 2.13434V5.8163C7.66886 6.33982 7.24759 6.77024 6.73521 6.77024H3.13159C3.19524 6.61725 3.29002 6.47409 3.41045 6.35105L7.25858 2.41926C7.37901 2.29621 7.51912 2.19937 7.66886 2.13434Z",
    fill: "#937DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4542_72083",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 13,
    width: 17,
    height: 17
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "68624d8b77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.1946 13.439H30.078V29.6677H14.1946V13.439Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4542_72083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30.0783 21.5578C30.0783 26.0356 26.5259 29.667 22.1416 29.667C17.7573 29.667 14.205 26.0356 14.205 21.5578C14.205 17.0782 17.7573 13.4486 22.1416 13.4486C26.5259 13.4486 30.0783 17.0782 30.0783 21.5578Z",
    fill: "#3925B6"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.7118 21.6765L22.5628 15.5851C22.4589 15.4326 22.3005 15.3558 22.1416 15.3558C21.9831 15.3558 21.8242 15.4326 21.7203 15.5851L17.5713 21.6765C17.4967 21.7808 17.4637 21.9094 17.4784 22.0344C17.482 22.1443 17.5242 22.2486 17.5951 22.3399L21.7459 27.5624C21.8481 27.6911 21.9918 27.7585 22.1416 27.7585C22.2913 27.7585 22.4351 27.6911 22.5372 27.5624L26.688 22.3399C26.759 22.2486 26.8011 22.1443 26.8047 22.0344C26.8194 21.9094 26.7864 21.7808 26.7118 21.6765Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.8045 22.0352C26.8009 22.1451 26.7588 22.2494 26.6878 22.3407L22.537 27.5632C22.4349 27.6919 22.2911 27.7593 22.1414 27.7593V23.943L26.8045 22.0352Z",
    fill: "#BDB0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M26.8045 22.0344L22.1414 20.126V15.3558C22.3002 15.3558 22.4587 15.4326 22.5626 15.5851L26.7116 21.6765C26.7862 21.7808 26.8192 21.9094 26.8045 22.0344Z",
    fill: "#BDB0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M22.1416 20.1265V23.9428L17.4784 22.0349L22.1416 20.1265Z",
    fill: "#AB9BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M26.8045 22.0349L22.1414 23.9428V20.1265L26.8045 22.0349Z",
    fill: "#937DFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M12.3368 21.0806H5.33375C5.07641 21.0806 4.8667 20.8663 4.8667 20.6039C4.8667 20.3409 5.07641 20.1266 5.33375 20.1266H12.3368C12.5936 20.1266 12.8034 20.3409 12.8034 20.6039C12.8034 20.8663 12.5936 21.0806 12.3368 21.0806Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.8034 18.218H5.33375C5.07641 18.218 4.8667 18.0038 4.8667 17.7408C4.8667 17.4784 5.07641 17.2641 5.33375 17.2641H12.8034C13.0607 17.2641 13.2704 17.4784 13.2704 17.7408C13.2704 18.0038 13.0607 18.218 12.8034 18.218Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M14.6711 15.3556H5.33375C5.07641 15.3556 4.8667 15.1413 4.8667 14.8788C4.8667 14.6159 5.07641 14.4016 5.33375 14.4016H14.6711C14.928 14.4016 15.1377 14.6159 15.1377 14.8788C15.1377 15.1413 14.928 15.3556 14.6711 15.3556Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M19.3398 12.494H5.33375C5.07641 12.494 4.8667 12.2798 4.8667 12.0168C4.8667 11.7544 5.07641 11.5401 5.33375 11.5401H19.3398C19.5967 11.5401 19.8064 11.7544 19.8064 12.0168C19.8064 12.2798 19.5967 12.494 19.3398 12.494Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M19.3398 9.63168H5.33375C5.07641 9.63168 4.8667 9.4174 4.8667 9.15494C4.8667 8.89201 5.07641 8.67773 5.33375 8.67773H19.3398C19.5967 8.67773 19.8064 8.89201 19.8064 9.15494C19.8064 9.4174 19.5967 9.63168 19.3398 9.63168Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContract);
export default __webpack_public_path__ + "static/media/smartContract.85dc8a1c63aaa2ecdad75448b7256022.svg";
export { ForwardRef as ReactComponent };